import React from 'react';
import DegreeForm from '@components/degreeForm/DegreeForm';
import { useGetCurrentUserQuery } from '@teachur/http-client';

const EditDegree = () => {
  const { data: user } = useGetCurrentUserQuery();

  if (!user) {
    return null;
  }

  return <DegreeForm degree={{ id: -1 }} />;
};

export default EditDegree;
